import SuperFetch from '../../../superFetch.js';

class RecommendTagApi {
  /**
   *  [추천 태그 리스트] 태그 리스트 요청하기
   */
  getRecommendTagList = (data) => SuperFetch.post('/recommend/tag/list', data);

  /**
   *  [추천 태그 상세] 추천 태그 상세 요청하기
   */
  getRecommendTagDetail = (data) => SuperFetch.post('/recommend/tag/detail', data);

  /**
   *  추천 태그 복사하기 전 필요한 데이터 가져오기
   */
  prepareCopyRecommendTag = (data) => SuperFetch.post('/recommend/tag/insert/preparation/copy', data);

  /**
   *  추천 태그 등록하기 전 필요한 데이터 가져오기
   */
  prepareCreateRecommendTag = (data) => SuperFetch.post('/recommend/tag/insert/preparation/insert', data);

  /**
   *  추천 태그에 연결할 아이템 리스트 요청하기
   */
  getRecommendTagItemList = (data) => SuperFetch.post('/recommend/tag/insert/preparation/list', data);

  /**
   *  태그 등록/복사하기
   */
  createRecommendTag = (data) => SuperFetch.post('/recommend/tag/insert', data);

  /**
   *  전체 태그 리스트 EXCEL 다운로드
   */
  getRecommendTagItemListExcelDownload = (data) =>
    SuperFetch.post('/recommend/tag/insert/preparation/list/excel/download', data);

  /**
   *  선택된 태그 리스트 EXCEL 다운로드
   */
  getSelectedRecommendTagItemListExcelDownload = (data) =>
    SuperFetch.post('/recommend/tag/insert/preparation/list/excel/download/selected', data);

  /**
   *  태그 리스트 EXCEL 업로드
   */
  setRecommendTagItemListExcelUpload = (data) =>
    SuperFetch.post('/recommend/tag/insert/preparation/list/excel/upload', data);
}

export default new RecommendTagApi();
